let tempArr = [];

export function handleMenu(menuData) {
  tempArr = [
    {
      id: menuData.id,
      name: menuData.name,
      type: menuData.type,
      isDown: menuData.isDown,
      sort: menuData.num,
    },
  ];

  if (menuData.downMenuInfo) {
    handleDown(menuData.downMenuInfo);
  }

  if (menuData.upMenuInfo) {
    handleUp(menuData.upMenuInfo);
  }

  return tempArr;
}

function handleDown(downData) {
  tempArr.push({
    id: downData.id,
    name: downData.name,
    type: downData.type,
    isDown: downData.isDown,
    sort: downData.num,
  });

  if (downData.downMenuInfo) {
    handleDown(downData.downMenuInfo);
  }
}

function handleUp(upData) {
  tempArr.unshift({
    id: upData.id,
    name: upData.name,
    type: upData.type,
    isDown: upData.isDown,
    sort: upData.num,
  });

  if (upData.upMenuInfo) {
    handleUp(upData.upMenuInfo);
  }
}

export function genQuery(allMenu) {
  if (allMenu.length === 1) {
    return {
      first: allMenu[0].id,
      type: allMenu[0].type,
      name: allMenu[0].name,
      isDown: allMenu[0].isDown,
    };
  } else if (allMenu.length === 2) {
    return {
      first: allMenu[0].id,
      second: allMenu[1].id,
      type: allMenu[1].type,
      name: allMenu[1].name,
      isDown: allMenu[1].isDown,
    };
  } else if (allMenu.length === 3) {
    return {
      first: allMenu[0].id,
      second: allMenu[1].id,
      third: allMenu[2].id,
      sort: allMenu[2].sort,
      type: allMenu[2].type,
      name: allMenu[1].name,
      isDown: allMenu[2].isDown,
    };
  } else if (allMenu.length === 4) {
    return {
      first: allMenu[0].id,
      second: allMenu[1].id,
      third: allMenu[2].id,
      fourth: allMenu[3].id,
      sort: allMenu[2].sort,
      type: allMenu[3].type,
      name: allMenu[1].name,
      isDown: allMenu[3].isDown,
    };
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/handleMenu.js